
export default function ScrollToTopPagination() {
    document.getElementsByClassName("app")[0].scrollTo(0,0)
}

